<template>
  <div class="content-wrapper pt-3 ">
    <div class="container-fluid ">
      <div class="card mb-5 height100 pr-3 pb-4">
        <div class="card-body"
             style="overflow: auto;height:1800px;display: -webkit-flex;-webkit-flex-direction: column;">
          <div class="row">
            <!--新建平台弹窗-->
            <el-dialog
                v-loading="load"
                :close-on-click-modal="false"
                :title="left_title"
                :visible.sync="dialogVisible_left"
                width="45%"
                top="1rem"
                :before-close="handleClose_Left">
              <div style="margin-bottom: 8px">
            <span><i class="fa fa-asterisk text-danger font10 ml-1"
                     aria-hidden="true"></i>选择功能组</span>
                <el-select v-model="group_name" multiple placeholder="请选择" @change="get_group_list">
                  <el-option
                      v-for="item in group_list"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div class="row height100" v-if="plat_attr_list.object_data!==undefined">
                <div class="col-lg-6  h-30">
                  <div class="card-header bg-info2 text-white">
                    平台信息
                  </div>
                  <div label="平台名称" style="margin-top: 20px">
                    <span><i class="fa fa-asterisk text-danger font10 ml-1"
                             aria-hidden="true"></i>平台名称</span>
                    <el-input v-model="plat_attr_list.object_data.name"></el-input>
                  </div>
                  <div class=" " v-for="(val,index) in plat_attr_list.object_data.static_attribute" :key="index">
                    <equip_attr_temp :Data="{'data':val,
                                                          'attr':{'type':'1','objType':'plat'}}">
                    </equip_attr_temp>
                  </div>
                </div>
                <div class="col-lg-6  h-30">
                  <div>
                    <div class="card-header bg-info2 text-white">
                      <span>平台数据库信息</span>
                    </div>
                    <div style="height: 600px">
                      <el-form class="form mt-3">
                        <div>
                          <div v-for="(item,index) in plat_attr_list.database_obj" :key="index">
                            <Input ref="chirld" @dataBase="get_dataBase"
                                   :Data="{index:index,'data':item}"></Input>
                          </div>
                        </div>
                      </el-form>
                      <div>
                        <i class="el-icon-circle-plus" id="add_input_list"
                           @click="add_input_List_length"></i>
                        <i class="el-icon-remove" id="remove_input_list"
                           v-if="temp_list.length>6"
                           @click="remove_input_List_length"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose_Left(0)">取 消</el-button>
                <el-button type="primary" @click="add_plat">提 交</el-button>
              </span>
            </el-dialog>
            <!--            功能组弹窗-->
            <el-dialog
                :close-on-click-modal="false"
                :title="func_title"
                :visible.sync="dialogVisible_func"
                width="65%"
                height="135vh"
                top="1vh">
              <func_dia :Data="{type:func_type}" v-if="func_flag" @get_platId="get_plat_id"
                        ref="pro_temp"></func_dia>
              <span slot="footer" class="dialog-footer">
                <el-button @click="clearData()">取 消</el-button>
                <el-button type="primary" @click="func_to_save">提 交</el-button>
              </span>
            </el-dialog>
            <!--中间部分-新建项目 -->
            <el-dialog
                :close-on-click-modal="false"
                :title="pro_title" :show-close="false"
                :visible.sync="dialogVisible_canter"
                width="65%"
                top="1vh">
              <temp_dia :Data="{type:pro_type,plat:platform_name}" v-if="pro_flag" @get_platId="get_plat_id"
                        @show_dia="show_diaFlag"
                        ref="pro_temp"></temp_dia>

            </el-dialog>
            <!--新增协议-->
            <el-dialog
                :title="right_title"
                :visible.sync="dialogVisible_right"
                width="30%"
                :show-close="false">
              <div class="card">
                <div class="card-body">
                  <div v-if="agree_flag">
                    <Building_input ref="chirld_building" @pushData="getSonBulidingData"
                                    :Data="{'title':right_title,'radio':radio}"
                    ></Building_input>
                  </div>
                </div>
              </div>
            </el-dialog>
          </div>
          <!--  用户信息        -->
          <el-row class="el_row">
            <el-col :span="24">
              <div class="card">
                <div class="card-body"
                     style="overflow: auto;display: -webkit-flex;-webkit-flex-direction: column;">
                  <el-row>
                    <el-col :span="2"><h5>用户信息</h5></el-col>
                    <el-col :span="22">
                      <el-button type="primary" @click="get_new_func_attr"
                                 class="button" v-if="$check_auth('NEW_FUNCTION_MODULE')"
                                 size="medium">新增功能模块
                      </el-button>

                      <el-button type="primary" @click="query_func_list();func_dialogVisible=true"
                                 class="button" v-if="$check_auth('SHOW_FUNCTION_MODULE')"
                                 size="medium" plain>编辑功能模块
                      </el-button>
                      <el-button type="primary" @click="get_new_auth_attr"
                                 v-if="$check_auth('NEW_PERMISSIONS')"
                                 class="button"
                                 size="medium">新增权限
                      </el-button>
                      <el-button type="primary" @click="query_func_list();kan_dialogVisible=true"
                                 class="button"
                                 size="medium" plain>编辑权限
                      </el-button>
                      <el-button type="primary" size="medium" v-if="$check_auth('NEW_FEATURE_GROUPS')"
                                 @click="func_title='新建功能组';query_funcgroup_attr()">新建功能组
                      </el-button>
                      <el-button type="primary" size="medium" v-if="$check_auth('SHOW_FEATURE_GROUPS')"
                                 @click="Query_funcGroup_list();centerDialogVisible = true" plain>编辑功能组
                      </el-button>
                      <el-button type="primary" size="medium" v-if="$check_auth('NEW_FEATURE_GROUPS_TYPE')"
                                 @click="left_title='新建功能组可用类型';func_type_dialog=true">
                        新建功能组可用类型
                      </el-button>
                      <el-button type="primary" size="medium" v-if="$check_auth('SHOW_FEATURE_GROUPS_TYPE')"
                                 @click="query_type_list();centerDialogVisible2 = true"
                                 plain>配置功能组可用类型
                      </el-button>
                      <el-button type="primary" size="medium" v-if="$check_auth('NEW_FEATURE_GROUPS_TYPE')"
                                 @click="left_title='新建用户';user_dialog=true">
                        新建用户
                      </el-button>
                      <el-button type="primary" size="medium"
                                 @click="query_alluser();edit_user_dialog = true"
                                 plain>编辑用户
                      </el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </el-col>
          </el-row>
          <!--  功能组信息        -->
          <el-dialog
              title="功能组信息"
              :visible.sync="centerDialogVisible"
              width="95%"
              top="5vh"
              center>
            <span> <el-row class="el_row">
            <el-col :span="24">
              <div class="card">
                <div class="card-body"
                     style="overflow: auto;height:450px;display: -webkit-flex;-webkit-flex-direction: column;">
                  <el-row>
                    <el-col :span="2"><h5>功能组详情</h5></el-col>
                  </el-row>
                  <el-table
                      :data="func_group_list"
                      height="550px"
                      border
                      style="width: 100%;margin-top: 20px">
                    <el-table-column
                        sortable
                        prop="id"
                        label="功能组id"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="name"
                        label="功能组名称"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="link_platform"
                        label="可用平台id列表"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="energy_type"
                        label="可用类型"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="ecmodel_provinces"
                        label="可用省份名称列表"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="ecmodel_city"
                        label="可用市名称列表"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="ecmodel_county"
                        label="可用区县名称列表"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="start_time"
                        label="创建时间"
                        width="260">
                    </el-table-column>
                    <el-table-column>
                      <template slot-scope="{row}">
                        <el-button size="small" type="primary" v-if="$check_auth('NEW_FEATURE_GROUPS')"
                                   @click="func_title='编辑功能组';toEdit_func(row) ">编辑
                        </el-button>
                        <el-button type="danger" size="small" v-if="$check_auth('DELETE_FEATURE_GROUPS')"
                                   @click="open_func(row)">删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <el-pagination :current-page.sync="currentPage4" :page-size.sync="pageSize4"
                             :page-sizes="[10,25,50,100]"
                             :total="total4"
                             align='center'
                             background
                             layout="total, sizes, prev, pager, next, jumper"
                             @size-change="Query_funcGroup_list(true)"
                             @current-change="Query_funcGroup_list">
              </el-pagination>
            </el-col>
          </el-row></span>
            <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
  </span>
          </el-dialog>
          <!--          功能组可用类型-->
          <el-dialog
              title="功能组可用类型"
              :visible.sync="centerDialogVisible2"
              width="95%"
              top="5vh"
              center>
            <span> <el-row class="el_row">
            <el-col :span="24">
              <div class="card">
                <div class="card-body"
                     style="overflow: auto;height:450px;display: -webkit-flex;-webkit-flex-direction: column;">
                  <vxe-table
                      border
                      resizable
                      :scroll-y="{enabled: false}"
                      :span-method="mergeRowMethod"
                      :data="func_type_list">
                    <vxe-column field="num" title="序号"></vxe-column>
                    <vxe-column field="func" title="项目类型名称"></vxe-column>
                    <vxe-column field="category" title="功能组可用类型名称"></vxe-column>
                    <vxe-column field="language" title="操作">
                      <template #default="{ row }">
                        <el-button size="small" type="primary"
                                   @click="func_title='编辑';toEdit_func_type(row) ">编辑
                        </el-button>
                        <el-button type="danger" size="small"
                                   @click="open_func_group(row)">删除
                        </el-button>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>
            </el-col>
          </el-row></span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="centerDialogVisible2 = false">取 消</el-button>
            </span>
          </el-dialog>
          <!--  功能组信息        -->
          <!--  平台详情        -->
          <el-row class="el_row" style="margin-top: 30px">
            <el-col :span="24">
              <div class="card">
                <div class="card-body"
                     style="overflow: auto;height:450px;display: -webkit-flex;-webkit-flex-direction: column;">
                  <el-row>
                    <el-col :span="2"><h5>平台详情</h5></el-col>
                    <el-col :span="21">
                      <el-button type="primary" style="margin-top: -10px; margin-bottom: 10px"
                                 v-if="$check_auth('NEW_PLAT')"
                                 @click="left_title='新建平台';
                            query_add_plat()">新建平台
                      </el-button>
                    </el-col>
                  </el-row>
                  <el-table
                      :data="platform_TableData"
                      height="550px"
                      class="mytable-scrollbar"
                      border
                      style="width: 100%;">
                    <el-table-column
                        prop="id"
                        label="平台ID"
                        width="160">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="平台名称"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="static_attribute.Index"
                        label="首页路径"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="static_attribute.Title"
                        label="标题名称"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="static_attribute.DomainName"
                        label="访问域名"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="static_attribute.OutsideIP"
                        label="外网IP"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        prop="static_attribute.OutsidePort"
                        label="外网端口号"
                        width="180">
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="start_time"
                        label="创建时间"
                        width="240">
                    </el-table-column>
                    <el-table-column label="操作" width="150">
                      <template slot-scope="{row}">
                        <el-button id="update" size="small" type="primary" v-if="$check_auth('EDIT_PLAT')"
                                   @click="left_title='编辑平台';toEdit_plat(row) ">编辑
                        </el-button>
                        <el-button type="danger" size="small" v-if="$check_auth('DELETE_PLAT')"
                                   @click="open_left(row)" style="margin-top: 1px">删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <el-pagination :current-page="currentPage1" :page-size="pageSize1"
                             :page-sizes="[10,25,50,100]"
                             :total="total1"
                             align='center'
                             background
                             layout="total, sizes, prev, pager, next, jumper"
                             @size-change="handleSizeChange1"
                             @current-change="handleCurrentChange1">
              </el-pagination>
            </el-col>
          </el-row>
          <!--    项目详情      -->
          <el-row style="margin-top: 30px">
            <el-col class="el_row" :span="24">
              <div class="card">
                <div class="card-body"
                     style="overflow: auto;height:450px;display: -webkit-flex;-webkit-flex-direction: column;">
                  <div style="height:35px">
                    <el-row>
                      <el-col :span="5"><h5 style="float:left;">项目详情</h5>
                        <el-select v-model="platform_name" @change="choicePlat" value-key="id"
                                   style="float:left;margin-top:-2px;margin-left:5px;width:55%"
                                   size="small">
                          <el-option
                              v-for="item in platform_data_list"
                              :key="item.name"
                              :label="item.name"
                              :value="item">
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="19">
                        <el-button type="primary" style="margin-top: -10px" v-if="$check_auth('NEW_PROJECT')"
                                   @click="project_id='';pro_flag=true;
                                       query_pro_attr();
                                   pro_title='新建项目';pro_type=0;dialogVisible_canter = true">
                          新建项目
                        </el-button>
                      </el-col>
                    </el-row>

                  </div>
                  <el-table
                      :data="project_list"
                      border
                      height="550px"
                      class="mytable-scrollbar"
                      style="width: 100%;">
                    <el-table-column
                        prop="id"
                        label="项目ID"
                      >
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="项目名称"
                      >
                    </el-table-column>
                    <el-table-column
                        prop="project_type"
                        label="项目类型"
                     >
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="start_time"
                        label="创建时间"
                       >
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="{row}">
                        <el-button size="small" type="info" v-if="$check_auth('NEW_PROJECT')"
                                   @click="pro_flag=true;pro_title='编辑项目';pro_type=1;
                                                           query_project_detail(row)">编辑
                        </el-button>
                        <el-button type="danger" size="small" v-if="$check_auth('DELETE_PROJECT')"
                                   @click="open_canter(row)">删除
                        </el-button>
                        <el-button size="small" type="success" v-if="$check_auth('DISPOSITION_PROJECT')"
                                   @click=" toConfig(row)">配置
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <el-pagination :current-page="currentPage2" :page-size="pageSize2"
                             :page-sizes="[10,25,50,100]"
                             :total="project_total"
                             align='center'
                             background
                             layout="total, sizes, prev, pager, next, jumper"
                             @size-change="handleSizeChange2"
                             @current-change="handleCurrentChange2">
              </el-pagination>
            </el-col>
          </el-row>
          <!--  协议配置        -->
          <el-row style="margin-top: 30px">
            <el-col class="el_row" :span="24">
              <div class="card">
                <div class="card-body"
                     style="overflow: auto;height:450px;display: -webkit-flex;-webkit-flex-direction: column;">
                  <el-row>
                    <el-col :span="2"><h5>协议详情</h5></el-col>
<!--                    <el-col :span="10">-->
                    <el-switch
                        v-model="radio"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="运行参数协议"
                        inactive-text="设定参数协议"
                        active-value="68"
                        inactive-value="69"
                    @change="currentPage3=1,query_AgreementInfo()">
                    </el-switch>
<!--                    </el-col>-->
<!--                    <el-col :span="22">-->
                      <el-button type="primary" style="margin-top: -10px;margin-bottom: 5px"
                                 v-if="$check_auth('NEW_PROTOCOL')"
                                 @click="right_title='新增协议';query_protocol_attr()">
                        新增协议
                      </el-button>
<!--                    </el-col>-->
                  </el-row>
                  <el-table v-loading="loading3"
                            :data="enter_Information"
                            height="550px"
                            border
                            class="mytable-scrollbar"
                            style="width: 100%;">
                    <el-table-column
                        prop="id"
                        label="协议功能码id"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        prop="protocol_name"
                        label="协议名称"
                        width="250">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="功能码名称"
                        width="240">
                    </el-table-column>
                    <el-table-column
                        v-if="radio==='68'"
                        prop="func_no_inside"
                        label="内部功能码"
                        width="240">
                    </el-table-column>
                    <el-table-column
                        v-if="radio==='68'"
                        prop="func_no_outside"
                        label="外部功能码"
                        width="240">
                    </el-table-column>
                    <el-table-column
                        v-if="radio==='69'"
                        prop="set_no_inside"
                        label="内部功能码"
                        width="240">
                    </el-table-column>
                    <el-table-column
                        v-if="radio==='69'"
                        prop="set_no_outside"
                        label="外部功能码"
                        width="240">
                    </el-table-column>
                    <el-table-column
                        prop="data_type"
                        label="数据类型"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        sortable
                        prop="start_time"
                        label="创建时间"
                        width="280">
                    </el-table-column>
                    <el-table-column label="操作" width="150">
                      <template slot-scope="{row}">
                        <el-button size="small" type="primary" v-if="$check_auth('NEW_PROTOCOL')"
                                   @click="right_title='协议编辑';query_agree_detail(row)">
                          编辑
                        </el-button>
                        <el-button type="danger" size="small" v-if="$check_auth('DELETE_PROTOCOL')"
                                   @click="open_right(row)" style="margin-top: 1px">删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <el-pagination :current-page="currentPage3" :page-size="pageSize3"
                             :page-sizes="[10,25,50,100]"
                             :total="total3"
                             background
                             align='center'
                             layout="total, sizes, prev, pager, next, jumper"
                             @size-change="handleSizeChange3"
                             @current-change="handleCurrentChange3" style="padding: 10px">
              </el-pagination>
            </el-col>
          </el-row>
          <!--  数据源配置表格        -->
          <el-row style="margin-top: 30px">
            <el-col class="el_row" :span="24">
              <div class="card">
                <div class="card-body"
                     style="overflow: auto;height:450px;display: -webkit-flex;-webkit-flex-direction: column;">
                  <div style="height:35px">
                    <el-row v-if="plat_show_flag">
                      <el-col :span="5"><h5 style="float:left;">数据源配置</h5>
                          <el-option
                              v-for="item in platform_data_list"
                              :key="item.name"
                              :label="item.name"
                              :value="item">
                          </el-option>
                      </el-col>
                      <el-col :span="19">
                        <el-button type="primary" style="margin-top: -10px;margin-bottom: 5px;margin-left: -250px" v-if="$check_auth('NEW_PROJECT')"
                                   @click="project_id='';pro_flag=true;
                                       query_pro_attr();
                                   pro_title='新增配置源';pro_type=0; soursdialogVisible = true">
                         新增配置源
                        </el-button>
                      </el-col>
                    </el-row>

                  </div>
                  <el-table
                      :data="SourceList"
                      border
                      height="550px"
                      class="mytable-scrollbar"
                      style="width: 100%;">
                    <el-table-column
                        prop="project_name"
                        label="项目名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="database_type"
                        label="数据库类型"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="database_name"
                        label="数据库名称"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="database_server_name"
                        label="服务用名"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="real_ip"
                        label="数据外网访问IP"
                    >
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="{row}">
                        <el-button size="small" type="primary" v-if="$check_auth('NEW_PROJECT')"
                                   @click="GetSourceInfo(row);">编辑
                        </el-button>
                        <el-button type="danger" size="small" v-if="$check_auth('DELETE_PROJECT')"
                                   @click="RoumoveSource(row)">删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <el-pagination :current-page="currentPage5" :page-size="pageSize5"
                             :page-sizes="[10,25,50,100]"
                             :total="SourceTotal"
                             align='center'
                             background
                             layout="total, sizes, prev, pager, next, jumper"
                             @size-change="handleSizeChange5"
                             @current-change="handleCurrentChange5">
              </el-pagination>
            </el-col>
          </el-row>
          <!--        新建权限/功能模块弹窗-->
          <el-dialog :title="auth_title" :visible.sync="attr_dialogVisible" v-if="attr_dialogVisible"
                     :show-close="false"
                     :close-on-press-escape="false"
                     :close-on-click-modal="false" width="30%" :destroy-on-close="true">
            <new_auth_dia v-if="auth_flag" :title="auth_title"></new_auth_dia>
            <span slot="footer" class="dialog-footer">
                <el-button @click="attr_dialogVisible = false,$store.state.new_auth_data = []">取 消</el-button>
                <el-button type="primary" @click="to_save">保 存</el-button>
            </span>
          </el-dialog>
          <!--                    查看权限裂表-->
          <el-dialog title="查看权限" :visible.sync="kan_dialogVisible" v-if="kan_dialogVisible"
                     :close-on-press-escape="false"
                     :close-on-click-modal="false" width="30%" :destroy-on-close="true">
            <el-table
                :data="tableData"
                default-expand-all
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="500px"
                border
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
              <el-table-column
                  prop="id"
                  label="id"
                  width="180">
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="名称"
              >
              </el-table-column>
              <el-table-column
                  label="操作">
                <template slot-scope="scope">
                  <el-button @click="query_detail(scope.row);auth_title='编辑权限'" type="text"
                             v-if="$check_auth('NEW_PERMISSIONS')&&scope.row.id.substr(0,2)==='62'"
                             size="small">
                    编辑
                  </el-button>
                  <el-button @click="detele_auth(scope.row)"
                             v-if="$check_auth('DELETE_PERMISSIONS')&&scope.row.id.substr(0,2)==='62'"
                             type="text" size="small">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="kan_dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="add_auth">保 存</el-button>
            </span>
          </el-dialog>
          <!--                    查看功能模块弹窗-->
          <el-dialog title="编辑功能模块" :visible.sync="func_dialogVisible" v-if="func_dialogVisible"
                     :close-on-press-escape="false"
                     :close-on-click-modal="false" width="30%" :destroy-on-close="true">
            <el-table
                :data="tableData2"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="500px"
                border
            >
              <el-table-column
                  prop="id"
                  label="id"
                  width="180">
              </el-table-column>
              <el-table-column
                  prop="chinese_name"
                  label="名称">
              </el-table-column>
              <el-table-column
                  label="操作">
                <template slot-scope="scope">
                  <el-button @click="query_funcm_detail(scope.row);auth_title='编辑功能模块'" type="text"
                             v-if="$check_auth('NEW_FUNCTION_MODULE')"
                             size="small">
                    编辑
                  </el-button>
                  <el-button @click="detele_func(scope.row)" v-if="$check_auth('DELETE_FUNCTION_MODULE')"
                             type="text" size="small">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="func_dialogVisible = false">取 消</el-button>
            </span>
          </el-dialog>
          <!--          新增功能组可用类型弹窗-->
          <el-dialog :title="left_title" :visible.sync="func_type_dialog"
                     @close="closeData" width="30%">
            <div>
              <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="150px" class="demo-dynamic">
                <el-form-item
                    prop="number"
                    label="序号">
                  <el-input v-model="order_name" style="width: 200px"></el-input>
                </el-form-item>
                <el-form-item
                    prop="email"
                    label="可用类型名称">
                  <el-input v-model="type_name" style="width: 200px"></el-input>
                </el-form-item>
                <el-form-item
                    label="项目分类名称">
                  <el-dropdown trigger="click" ref="Dropdown" hide-on-click>
                    <el-input v-model="pro_name" placeholder="请选择要配置的内容"
                              :readonly="true"
                              clearable @focus="get_select_data">
                    </el-input>
                    <el-dropdown-menu slot="dropdown" style="width: 230px;max-height: 300px;overflow-y: scroll">
                      <el-tree :data="tree_options" ref="func_tree" class="filter-tree" accordion
                               node-key="label" v-if="tree_flag"
                               show-checkbox :check-strictly="true"
                               :default-checked-keys="checked_list"
                               @check-change="get_tree_data">
                      </el-tree>
                    </el-dropdown-menu>
                  </el-dropdown>
<!--                  <el-input v-model="domain.value" style="width: 200px"></el-input>-->
<!--                  <el-button type="text" @click.prevent="removeDomain(domain)"-->
<!--                             v-if="dynamicValidateForm.domains.length>1">删除-->
<!--                  </el-button>-->
                </el-form-item>
<!--                <div>-->
<!--                  <el-button type="text" @click="addDomain">+新增项目分类名称</el-button>-->
<!--                </div>-->
                <el-form-item>
                  <el-button type="primary" @click="submitForm()">提交</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <!--          编辑功能组可用类型弹窗-->
          <el-dialog title="编辑" :visible.sync="edit_func_type_dialog"
                     @close="closeData" width="30%">
            <div>
              <el-form ref="dynamicValidateForm" label-width="150px" class="demo-dynamic">
                <el-form-item prop="email" label="项目功能类型">
                  <el-dropdown trigger="click" ref="Dropdown" hide-on-click>
                    <el-input v-model="pro_name" placeholder="请选择要配置的内容"
                              :readonly="true"
                              clearable>
                    </el-input>
                    <el-dropdown-menu slot="dropdown" style="width: 230px;max-height: 300px;overflow-y: scroll">
                      <el-tree :data="tree_options" ref="func_tree" class="filter-tree" accordion
                               node-key="label" v-if="tree_flag"
                               show-checkbox :check-strictly="true"
                               :default-checked-keys="checked_list"
                               @check-change="get_tree_data">
                      </el-tree>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="save_pro_type">提交</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-dialog>
          <!--          新增用户-->
          <el-dialog :title=left_title :visible.sync="user_dialog"
                     @close="closeData" width="30%">
            <div v-if="left_title==='新建用户'">
              <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="150px" class="demo-dynamic">
                <el-form-item
                    prop="email"
                    label="用户名">
                  <el-input v-model="user_name" style="width: 200px" placeholder="手机号"></el-input>
                </el-form-item>
                <el-form-item
                    label="密码">
                  <el-input placeholder="请输入密码" v-model="password" show-password style="width: 200px"></el-input>

                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="add_user">提交</el-button>
                </el-form-item>


              </el-form>
            </div>
            <div v-if="left_title==='编辑用户'">
              <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="150px" class="demo-dynamic">
              <el-form-item
                  prop="email"
                  label="用户名">
                <el-input v-model="new_phone" style="width: 200px" placeholder="手机号" disabled="true"></el-input>
              </el-form-item>
              <el-form-item
                  label="密码">
                <el-input placeholder="请输入密码" v-model="password" show-password style="width: 200px"></el-input>

              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="edit_user">提交</el-button>
              </el-form-item>
              </el-form>

            </div>
          </el-dialog>
          <!--          编辑用户-->
          <el-dialog title='编辑用户' :visible.sync="edit_user_dialog"
                     @close="closeData" width="30%">

              <el-table
                  :data="all_user"
                  style="width: 100%;margin-bottom: 20px;"
                  row-key="id"
                  height="500px"
                  border>
                <el-table-column
                    prop="name"
                    label="用户名"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="phone"
                    label="手机号">
                </el-table-column>
                <el-table-column
                    label="操作">
                  <template slot-scope="scope">
                    <el-button type="primary" plain @click="new_phone=scope.row.phone;left_title='编辑用户';user_dialog=true"
                               size="small">
                      重设密码
                    </el-button>
                    <el-button type="danger" plain size="small" @click="handleUserDelete(scope.row)">
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>


          </el-dialog>
<!--          新增配置源-->
          <el-dialog title="新增配置源" :visible.sync="soursdialogVisible" width="30%" :v-show="soursdialogVisible">
            <SourceInput @close="closeSource" @AddSuccess="closeSourceDialog" v-if="soursdialogVisible"></SourceInput>
          </el-dialog>
<!--          编辑配置源-->
          <el-dialog title="编辑配置源" :visible.sync="province_flag" width="30%" :v-show="province_flag">
             <SourceInfo :data="SourceInfo" @close="CloseEditSource" @AddSuccess="CloseEditSourceDialog" v-if="province_flag"></SourceInfo>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Building_input from "@/components/IBMS/function/general_func_group/building_input.vue"
import temp_dia from "@/components/IBMS/platform/temp_dia.vue";
import new_auth_dia from "@/components/IBMS/platform/new_auth_dia.vue";
import func_dia from "@/components/IBMS/platform/funcGrounp_dia.vue";
import Input from "@/components/IBMS/function/general_func_group/new_input.vue"
import equip_attr_temp from "@/components/IBMS/function/special_func_group/equip_attr_temp.vue";
import {passwordrules} from "caniuse-lite/data/features";
import JSEncrypt from "jsencrypt";
import SourceInput from "@/components/IBMS/function/general_func_group/SourceInput.vue";
import SourceInfo from "@/components/IBMS/function/general_func_group/SourceInfo.vue";

export default {
  name: "architectural_overview",
  computed: {
    passwordrules() {
      return passwordrules
    }
  },
  components: {
    temp_dia, func_dia, Building_input,
    Input,
    new_auth_dia,equip_attr_temp,
    SourceInput,
    SourceInfo
  },
  data() {
    return {
      //当前表格多少条
      pageSize5: 10,
      //配置源表格的总条数
      SourceTotal:1,
      //获取配置源详情
      SourceInfo: {},
      //配置源列表
      SourceList: [],
      //控制新增配置源的弹窗
      soursdialogVisible: false,
      //控制编辑配置源的弹窗
      province_flag: false,
      //序号
      order_name:'',
      centerDialogVisible_adduser: false,
      centerDialogVisible_user: false,
      load: false,
      dynamicValidateForm: {
        domains: [{
          value: ''
        }],
      },
      tree_flag: true,
      type_name: '',
      func_type_dialog: false,//功能组可用类型弹窗
      centerDialogVisible: false,
      centerDialogVisible2: false,
      loading1: false,
      loading3: false,
      fullscreenLoading: false,
      platformVisible: false,
      temp_list: [],
      auth_title: '新建权限',
      auth_attr_list: [],
      building_list: [{'index': 0}],
      left_title: '新建平台',
      right_title: '新增协议',
      platform_Id: '',
      platform_id: '',
      informationId: '',
      project_id: '',
      currentPage1: 1, // 当前页码
      currentPage4: 1, // 当前页码
      total1: 0, // 总条数
      total4: 0, // 总条数
      pageSize1: 10, // 每页的数据条数
      pageSize4: 10, // 每页的数据条数
      currentPage2: 1, // 当前页码
      pageSize2: 10, // 每页的数据条数
      currentPage3: 1, // 当前页码
      currentPage5: 1, // 当前页码
      total3: 0, // 总条数
      pageSize3: 10, // 每页的数据条数
      platform_TableData: [],
      platform_data_list: [],
      enter_Information: [],
      platform_name: '',
      protocol_name: '',
      dialogVisible_left: false,
      dialogVisible_canter: false,
      dialogVisible_func: false,
      dialogVisible_right: false,
      getSonBulidingData_child: [],
      project_list: [],
      project_total: 0,
      pro_type: 0,//0xinji
      func_type: 0,//0xinji
      pro_title: '新建项目',
      func_title: '新建功能组',
      pro_flag: true,
      func_flag: true,
      show_GetSonBulidingData: true,
      database_info: [],//数据库信息
      attr_dialogVisible: false,
      kan_dialogVisible: false,
      func_dialogVisible: false,
      func_name: '',
      options: [],
      tree_options: [],
      func_id: '',
      tableData: [],
      tableData2: [],
      show_input: 0,
      plat_flag: true,
      plat_flag_son: true,
      func_group_list: [],//功能组列表
      func_attr_list: [],
      func_group_id: '',
      func_type_list: [],
      edit_func_type_dialog: false,
      checked_list: [],
      pro_name: '',
      category_name: '',
      fun_name: '',
      pro_cat_name: [],
      t_func_id: '',
      auth_flag: true,
      plat_attr_list: [],
      remark: '',
      remark_list: [{key: '', value: ''}],
      group_list: this.$store.state.func_list,
      group_name: '',
      bb_flag: true,
      agree_attr_list: [],
      agree_flag: true,
      user_dialog:false,
      edit_user_dialog:false,
      password:'',
      user_name:'',
      new_phone:'',
      all_user:[],
      user_data:[],
      radio: '68',
      plat_show_flag:'true'
    }
  },
  created() {
    const query = this.$route.query
    query.projectSize && (this.pageSize2 = parseInt(query.projectSize))
    query.projectCurrent && (this.currentPage2 = parseInt(query.projectCurrent))
  },
  mounted() {
    this.query_Info();//查询平台列表
    this.query_all_plat();//查询全部平台--项目用
    this.query_AgreementInfo();//查询协议列表
    this.query_sorcelist()
  },
  methods: {
    //查询所有用户
    query_alluser() {
      this.tableData = []
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectTree',
        // url: 'http://192.168.10.66:8001/api/IBMS/Public/QueryObjectTree',
        params:
            {
              "object_code": '61'
            }
      }).then((response) => {
        console.log(response.data)
        this.all_user=response.data.content
        // for (let i in response.data.content) {
        //   this.tableData.push({
        //     'id': response.data.content[i].id,
        //     'name': response.data.content[i].chinese_name,
        //     'children': []
        //   })
        //   for (let x in response.data.content[i].children) {
        //     this.tableData[i].children.push(
        //         {
        //           'id': response.data.content[i].children[x].id,
        //           'name': response.data.content[i].children[x].chinese_name,
        //         }
        //     )

      })
    },
    //编辑or新增用户
    todo_user(){
      if(this.left_title==='新增用户'){
        this.add_user()
      }else if(this.left_title==='编辑用户'){
        this.edit_user()
      }
    },
    //编辑用户
    edit_user(){
      let encryptor = new JSEncrypt()
      encryptor.setPublicKey(this.$store.state.public_key)
      let rsaPassWord = encryptor.encrypt(this.password)
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Login/ResetPassword',
        // url:'http://192.168.10.66:8001/api/IBMS/Login/ResetPassword',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "phone": this.new_phone,
            "new_password": rsaPassWord
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.user_dialog = false
          this.user_name= ''
          this.password= ''
        } else {
          this.$message({
            message: '未知异常',
            type: 'error'
          });
        }
      })
    },
    //新增用户
    add_user(){
      let encryptor = new JSEncrypt()
      encryptor.setPublicKey(this.$store.state.public_key)
      let rsaPassWord = encryptor.encrypt(this.password)
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/DeliveryPlatform/AddUserWithoutPhone',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "username": this.user_name,
            "password": rsaPassWord
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            message: '新增成功',
            type: 'success'
          });
          this.user_dialog = false
        } else {
          this.$message({
            message: '未知异常',
            type: 'error'
          });
        }
      })
    },
    get_group_list(data) {
      this.plat_attr_list.platform_belongs_to_function_group = data
    },

    //子组建传回的数据库信息
    get_dataBase(data, index) {
      this.plat_attr_list.database_obj[index] = data
    },
    //新建平台
    add_plat() {
      if (this.left_title === '新建平台') {
        var arry = this.plat_attr_list.database_obj
        for (let i in arry) {
          if (arry[i].database_name === '' || arry[i].database_ip === '' || arry[i].database_port === ''
              || arry[i].database_user === '' || arry[i].database_passwd === '' || arry[i].database_server_name === ''
              || arry[i].database_type === '' || arry[i].real_ip === '' || arry[i].real_port === '') {
            this.$message({
              type: 'error',
              message: '请填写数据库完整信息'
            });
            return;
          }
        }
        let check = this.$check_data([this.$store.state.plat_data.object_data.static_attribute])
        if (!check) {
          return
        }

        if (this.plat_attr_list.platform_belongs_to_function_group.length === 0) {
          this.$message({
            type: 'error',
            message: '请选择功能组'
          });
          return;
        }
        this.fullscreenLoading = true
        this.$axios({
          method: 'post',
          url: this.IBMS_API + 'IBMS/Public/AddNewObject',
          data: {
            "version": "V1.1",
            "timestamp": "0",
            "data": {
              "object_data":this.$store.state.plat_data,

            }
          },
        }).then((response) => {
          this.fullscreenLoading = false
          if (response.data.result === 200) {
            this.$message({
              message: '录入成功',
              type: 'success'
            });
            this.dialogVisible_left = false
            this.query_Info()
          } else if (response.data.result === 9999) {
            this.$message({
              message: '未知异常',
              type: 'error'
            });
          }
        })
      } else {
        this.edit()
      }
    },
    show_diaFlag(data) {
      this.dialogVisible_canter = data
      this.pro_flag = false
      this.query_project_list()
    },
    //新增用户
    editUser() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'global/EditUser',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "attr_list": this.$store.state.project_data,
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            type: 'success',
            message: '添加成功!'
          });
        }
        this.centerDialogVisible_adduser = false
      })
    },
    //新增/修改项目分类关联
    save_pro_type() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/DeliveryPlatform/EditProjectType',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            // "func_group_type_name": this.category_name,
            "project_type_name": this.fun_name,
            "project_category_name_list": this.pro_cat_name,
            "order_number": +this.order_name,
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            type: 'success',
            message: '修改成功!'
          })
        }
        this.edit_func_type_dialog = false
        this.query_type_list()

      })
    },
    get_tree_data() {
      let list = this.$refs.func_tree.getCheckedKeys()
      this.pro_cat_name = list
      this.pro_name = list.toString()
    },
    //获取项目可用类型
    get_select_data() {
      // this.tree_flag=false
      this.$axios.post(this.IBMS_API + 'Common/classifyPj').then((response) => {
        this.tree_options = this.r_obj(response.data.content)
      })
      // this.query_tree_info()
    },
    //递归函数
    r_obj(data) {
      let temp = []
      for (let i in data) {
        let label = data[i].name
        let id = data[i].id
        let sonList = []
        let flag = true
        if (data[i].sonList && data[i].sonList.length !== 0) {
          sonList = this.r_obj(data[i].sonList)
        } else {
          sonList = undefined
          flag = false
        }
        temp.push({'label': label, 'value': id, 'children': sonList, 'disabled': flag})
      }
      return temp
    },
    handleUserDelete(row) {
      this.$confirm('是否确定删除该用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          url: this.IBMS_API + 'IBMS/Public/DeprecatOrDeleteObject',
          data: {
            "version": "1.1",
            "data": {
              "id_list": [row.id],
              "flag": 'delete'
            }
          },
        }).then((res) => {
          if(res.data.result===200){
            this.$message ({
              type: 'success',
              message: '删除成功!'
            });
            this.query_alluser()
          }else{
            this.$message ({
              type: 'error',
              message: '删除失败!'
            });
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //合并列
    mergeRowMethod({row, _rowIndex, column, visibleData}) {
      const cellValue = row[column.property]
      if (cellValue) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return {rowspan: 0, colspan: 0}
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return {rowspan: countRowspan, colspan: 1}
          }
        }
      }
    },

    query_type_list() {
      this.func_type_list = []
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/DeliveryPlatform/QueryFuncGroupTypeList',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {}
        },
      }).then((response) => {
        if (response.data.result === 200) {
          // this.func_type_list=response.data.content.func_group_name_list
          for (let i in response.data.content.func_category_name_list) {
            // for (let x in response.data.content.func_category_name_list[i].category_name_list) {
              this.func_type_list.push({
                'func': response.data.content.func_category_name_list[i].func_category_name,
                'category': response.data.content.func_category_name_list[i].project_category_list,
                'num': response.data.content.func_category_name_list[i].order_number
              })
            // }
          }
        }
      })
    },
    //关闭可用类型弹窗
    closeData() {
      this.dynamicValidateForm = {
        domains: [{
          value: ''
        }],
        name: ''
      }
      this.pro_name=''
      this.password=''
      this.type_name=''
      this.checked_list=[]
      this.func_type_dialog = false
    },
    submitForm() {
      // var list = []
      // for (let i in this.dynamicValidateForm.domains) {
      //   list.push(this.dynamicValidateForm.domains[i].value)
      // }
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/DeliveryPlatform/CreateFuncGroupType',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "func_group_type_name": this.type_name,
            "project_type_name_list": this.pro_name.split(','),
            "order_number": +this.order_name
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            type: 'success',
            message: '新增成功!'
          })
        }
        this.func_type_dialog = false
      })
    },
    // removeDomain(item) {
    //   var index = this.dynamicValidateForm.domains.indexOf(item)
    //   if (index !== -1) {
    //     this.dynamicValidateForm.domains.splice(index, 1)
    //   }
    // },
    // addDomain() {
    //   this.dynamicValidateForm.domains.push({
    //     value: '',
    //     key: Date.now()
    //   });
    // },
    clearData() {
      this.func_flag = false
      this.dialogVisible_func = false
      this.func_group_id = ''
      this.$store.commit('set_func_user', [])
      this.$store.commit('set_county_list', [])
    },
    //查询功能组详情
    query_func_detail() {
      this.func_flag = false
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectDetailTree',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "id": this.func_group_id,
          }
        },
      }).then((response) => {
        this.func_attr_list = response.data.content
        this.$store.commit('set_funcGroup_data', this.func_attr_list.object_data)
        this.func_flag = true
      })
    },
    func_to_save() {
      if (this.func_title === '新建功能组') {
        this.add_funcgroup()
      } else {
        this.edit_funcgroup()
      }
    },
    //编辑功能组
    edit_funcgroup() {
      let check = this.$check_data([this.$store.state.funcGroup_data.static_attribute])
      if (!check) return
      if (this.$store.state.funcGroup_data.model.length === 0 || this.$store.state.funcGroup_data.permission.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择权限或功能模块'
        });
        return;
      }
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/UpdateObject',
        data: {
          "version": "V1.1",
          "data": {
            "object_data": this.$store.state.funcGroup_data,
          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            type: 'success',
            message: '编辑成功'
          });
        }
        this.dialogVisible_func = false
        this.clearData()
        this.Query_funcGroup_list()
      })
    },
    //新增功能组
    add_funcgroup() {
      let check = this.$check_data([this.$store.state.funcGroup_data.static_attribute])
      if (!check) return
      if (this.$store.state.funcGroup_data.model.length === 0 || this.$store.state.funcGroup_data.permission.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择权限或功能模块'
        });
        return;
      }
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/AddNewObject',
        data: {
          "version": "V1.1",
          "data": {
            "object_data": this.$store.state.funcGroup_data,
          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            type: 'success',
            message: '新增成功'
          });
          this.dialogVisible_func = false
          this.clearData()
        }
      })
    },
    //编辑功能组
    toEdit_func(row) {
      this.func_type = 1
      this.func_group_id = row.id
      this.query_func_detail()
      this.dialogVisible_func = true
    },
    //编辑功能组可用类型
    toEdit_func_type(row) {
      console.log(row,'row')
      this.order_name = row.num
      this.fun_name = row.func
      this.category_name = row.category
      this.pro_name = String(row.category)
      this.checked_list= row.category
      this.edit_func_type_dialog = true
      this.get_select_data()
    },
    //编辑：获取勾选数据
    query_tree_info() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/DeliveryPlatform/QueryProjectTypeInfo',
        data: {
          "version": "V1.1",
          "data": {
            "project_type_name": this.category_name,
            "func_group_type_name": this.fun_name
          }
        }
      }).then((response) => {
        this.checked_list = response.data.content.category_name_list
        this.pro_name = this.checked_list.toString()
        this.tree_flag = false
        this.$nextTick(() => {
          this.tree_flag = true
        })
      })
    },
    //查询功能组表单相
    query_funcgroup_attr() {
      this.func_flag = false
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/GetNewObjectAttribute',
        data: {
          "version": "V1.1",
          "data": {
            "object_code": '67'
          }
        }
      }).then((response) => {
        this.func_attr_list = response.data.content
        this.$store.commit('set_funcGroup_data', this.func_attr_list.object_data)
        this.dialogVisible_func = true
        this.func_flag = true
      })
    },
    //查询功能组列表
    Query_funcGroup_list(isSizeChange = false) {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          "object_code": '67',
          "page": isSizeChange === true ? "1" : this.currentPage4,
          "size": this.pageSize4,
        }
      }).then((response) => {
        this.func_group_list = response.data.content.data
        this.total4 = response.data.content.totalElements
      })
    },
    // query_item(){
    //
    // },
    //查询项目表单相
    query_pro_attr() {
      this.pro_flag = false
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/GetNewObjectAttribute',
        data: {
          "version": "1.1",
          "data": {
            "object_code": '11'
          }
        },
      }).then((response) => {
        this.project_attr_list = response.data.content
        this.$store.commit('set_project_data', this.project_attr_list)
        this.pro_flag = true
      })
    },
    platformVisible_close() {
      this.platformVisible = false
      this.pageSize1 = 10
      this.query_Info()
    },
    //查询平台表单相
    query_add_plat() {
      this.plat_flag_son = false
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/GetNewObjectAttribute',
        data: {
          "version": "1.1",
          "data": {
            'object_code': '10',
          }
        }
      }).then((response) => {
        if (response.data.result === 200) {
          this.plat_attr_list = response.data.content
          this.$store.commit('set_plat_data', this.plat_attr_list)

        }

      })

      this.dialogVisible_left = true;
      this.$nextTick(() => {
        this.plat_flag_son = true
      })
    },

    // 查询协议表单相
    query_protocol_attr() {
      this.agree_flag = false
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/GetNewObjectAttribute',
        data: {
          "version": "1.1",
          "data": {
            'object_code': this.radio,
          }
        }
      }).then((response) => {
        this.agree_attr_list = response.data.content.object_data
        this.$store.commit('get_protocol_data', response.data.content.object_data)
        this.agree_flag = true
        this.dialogVisible_right = true
      })
    },
    //删除功能权模块
    detele_func(row) {
      this.$confirm('是否确认删除该功能模块?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          url: this.IBMS_API + 'IBMS/Public/DeprecatOrDeleteObject',
          data: {
            "version": "1.1",
            "data": {
              'id_list': [row.id],
              'flag': 'delete',
            }
          }
        }).then((response) => {
          if (response.data.result === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }

          this.query_func_list()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //删除权限
    detele_auth(row) {
      this.$confirm('是否确认删除该权限?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          url: this.IBMS_API + 'IBMS/Public/DeprecatOrDeleteObject',
          data: {
            "version": "1.1",
            "data": {
              'id_list': [row.id],
              'flag': 'delete',
            }
          }
        }).then((response) => {
          if (response.data.result === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }

          this.query_func_list()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    query_funcm_detail(row) {
      this.t_func_id = row.id
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectDetailTree',
        data: {
          "version": "1.1",
          "data": {
            'id': row.id,
          }
        }
      }).then((response) => {
        this.auth_attr_list = response.data.content
        this.$store.commit('set_new_auth_data', response.data.content.object_data)
        this.attr_dialogVisible = true
      })
    },
    //查询权限详情
    query_detail(row) {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectDetailTree',
        data: {
          "version": "1.1",
          "data": {
            'id': row.id,
          }
        }
      }).then((response) => {
        this.auth_attr_list = response.data.content.object_data
        this.func_id = response.data.content.func_id
        this.func_name = response.data.content.func_name
        this.$store.commit('set_new_auth_data', response.data.content.object_data)
        this.attr_dialogVisible = true

      })
    },
    choiceFunc(data) {
      this.func_id = data
    },
    //获取功能模块列表
    query_func_list() {
      this.tableData2 = []
      this.tableData = []
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectTree',
        params: {
          "object_code": '63'
        }
      }).then((response) => {
        for (let i in response.data.content) {
          this.tableData2.push({
            'id': response.data.content[i].id, 'name': response.data.content[i].name,
            'chinese_name': response.data.content[i].chinese_name
          })
        }
        for (let i in response.data.content) {
          this.tableData.push({
            'id': response.data.content[i].id,
            'name': response.data.content[i].chinese_name,
            'children': []
          })
          for (let x in response.data.content[i].children) {
            this.tableData[i].children.push(
                {
                  'id': response.data.content[i].children[x].id,
                  'name': response.data.content[i].children[x].chinese_name,
                }
            )
          }
        }
      })
    },
    //查询权限列表
    query_role_to_func_auth() {
      this.tableData = []
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectTree',
        params:
            {
              "object_code": '62'
            }
      }).then((response) => {
        for (let i in response.data.content) {
          this.tableData.push({
            'id': response.data.content[i].id,
            'name': response.data.content[i].chinese_name,
            'children': []
          })
          for (let x in response.data.content[i].children) {
            this.tableData[i].children.push(
                {
                  'id': response.data.content[i].children[x].id,
                  'name': response.data.content[i].children[x].chinese_name,
                }
            )
          }
        }
      })
    },
    to_save() {
      if (this.auth_title === '新增权限') {
        this.add_auth()
      } else if (this.auth_title === '编辑权限') {
        this.update_auth()
      } else if (this.auth_title === '编辑功能模块') {
        this.edit_func()
      } else {//新增功能模块
        this.add_func()
      }
    },
    //编辑功能模块
    edit_func() {
      if (this.$store.state.new_auth_data.chinese_name === null || this.$store.state.new_auth_data.name === '') {
        this.$message({
          message: '请填写完整信息',
          type: 'error'
        });
        return
      }
      this.$axios({
        url: this.IBMS_API + 'IBMS/Public/UpdateObject',
        method: 'post',
        data: {
          "version": "1.1",
          "data": {
            "object_data": this.$store.state.new_auth_data,
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.attr_dialogVisible = false
          this.auth_attr_list = []
          this.options = []
          this.value = null
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
        }
        this.query_func_list()
        this.t_func_id = ''
      })
    },
    //添加功能模块
    add_func() {
      if (this.$store.state.new_auth_data.chinese_name === null || this.$store.state.new_auth_data.name === '') {
        this.$message({
          message: '请填写完整信息',
          type: 'error'
        });
        return
      }
      this.$axios({
        url: this.IBMS_API + 'IBMS/Public/AddNewObject',
        method: 'post',
        data: {
          "version": "1.1",
          "data": {
            "object_data": this.$store.state.new_auth_data,
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.attr_dialogVisible = false
          this.auth_attr_list = []
          this.options = []
          this.value = null
          this.$message({
            message: '创建成功',
            type: 'success'
          });
        }
        this.query_func_list()
        this.t_func_id = ''
      })
    },
    //添加权限
    add_auth() {
      if (this.$store.state.new_auth_data.chinese_name === null || this.$store.state.new_auth_data.name === ''
          || this.$store.state.new_auth_data.parent === null || this.$store.state.new_auth_data.type === null) {
        this.$message({
          message: '请填写完整信息',
          type: 'error'
        });
        return
      }
      this.$axios({
        url: this.IBMS_API + 'IBMS/Public/AddNewObject',
        method: 'post',
        data: {
          "version": "1.1",
          "data": {
            'object_data': this.$store.state.new_auth_data,
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.attr_dialogVisible = false
          this.$store.commit('set_new_auth_data', [])
          this.$message({
            message: '创建成功',
            type: 'success'
          });
        }
      })
    },
    //更新-编辑权限
    update_auth() {
      if (this.$store.state.new_auth_data.chinese_name === null || this.$store.state.new_auth_data.name === ''
          || this.$store.state.new_auth_data.parent === null || this.$store.state.new_auth_data.type === null) {
        this.$message({
          message: '请填写完整信息',
          type: 'error'
        });
        return
      }
      this.$axios({
        url: this.IBMS_API + 'IBMS/Public/UpdateObject',
        method: 'post',
        data: {
          "version": "1.1",
          "data": {
            'object_data': this.$store.state.new_auth_data,
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.attr_dialogVisible = false
          this.$store.commit('set_new_auth_data', [])
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
        }
        this.query_func_list()
      })
    },
    get_func_list() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'global/QueryFuncAuth',
        data: {
          "version": "1.1",
          "data": {
            'platform_id': this.platform_Id,

          }
        }
      }).then((response) => {
        for (let i in response.data.content) {
          this.options.push({
            'id': response.data.content[i].id,
            'name': response.data.content[i].name,
          })
        }
      })
    },
    //查询新建权限表单相--‘62’
    get_new_auth_attr() {
      this.auth_flag = false
      this.auth_title = '新增权限'
      this.$axios({
        url: this.IBMS_API + 'IBMS/Public/GetNewObjectAttribute',
        method: 'post',
        data: {
          "version": "1.1",
          "data": {
            "object_code": '62'
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.auth_attr_list = response.data.content.object_data
          this.$store.commit('set_new_auth_data', this.auth_attr_list)
          this.attr_dialogVisible = true
          this.auth_flag = true
        }
      })
    },
    //获取功能模块属性列表
    get_new_func_attr() {
      this.auth_title = '新增功能模块'
      this.$axios({
        url: this.IBMS_API + 'IBMS/Public/GetNewObjectAttribute',
        method: 'post',
        data: {
          "version": "1.1",
          "data": {
            "object_code": '63'
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.auth_attr_list = response.data.content
          this.$store.commit('set_new_auth_data', this.auth_attr_list.object_data)
          this.attr_dialogVisible = true


        }
      })
    },
    //查询全部平台
    query_all_plat() {
      this.plat_show_flag = false
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          "object_code": '10',
        },
      }).then((response) => {
        this.platform_data_list = response.data.content.data
        this.platform_name = this.platform_data_list[0].name
        this.platform_Id = this.platform_data_list[0].id
        this.platform_id = this.platform_data_list[0].id
        this.query_project_list()
        this.plat_show_flag = true
      })
    },
    get_plat_id(data) {
      this.platform_id = data
    },
    choicePlat(data) {
      this.platform_Id = data.id
      this.platform_id = data.id
      this.platform_name = data.name
      this.query_project_list()
    },
    toConfig(row) {
      this.$store.commit('push_project_id', row.id)
      this.$store.commit('push_project_name', row.name)
      this.$store.commit('push_platform_name', this.platform_name)
      this.$store.commit('push_platform_id', this.platform_Id)
      this.$store.commit('push_project_code', row.real_code)
      this.$router.push({
        path: '/IBMS/config/OperationConfigIndex',
      })
    },
    //查询项目信息
    query_project_detail(row) {
      // this.platform_id = this.platform_Id
      // this.project_id = row.id
      this.pro_flag = false
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectDetailTree',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "id": row.id,
          }
        },
      }).then((response) => {
        this.$store.commit('set_project_data', response.data.content)
        this.pro_flag = true
        this.dialogVisible_canter = true
      })
    },
    //删除该数据源
    DeleteSource(id){
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/DeliveryPlatform/DeleteDataSource',
        data:{
          "version": "V1.1",
          "timestamp": "0",
          "data": {
             "id":id
           }
      },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
        this.query_sorcelist()
      })
    },
    //删除项目
    detele_project() {
      this.fullscreenLoading = true
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/DeprecatOrDeleteObject',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "id_list": [this.project_id],
            "flag": 'delete'
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
        this.query_project_list()
        this.fullscreenLoading = false
      })
    },
    //项目列表
    query_project_list() {
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          "platform_id": this.platform_Id,
          "page": this.currentPage2,
          "size": this.pageSize2,
          "object_code": '11',
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.project_list = response.data.content.data
          this.project_total = response.data.content.totalElements
        }
      })
    },
    getSonBulidingData(data) {
      this.dialogVisible_right = data
      this.query_AgreementInfo()
    },
    //关闭新增配置源弹窗
    closeSource(data){
        this.soursdialogVisible = data
    },
    //新建配置源成功后关闭弹窗
    closeSourceDialog(data){
        this.soursdialogVisible = data
       this.query_sorcelist()
    },
    //关闭编辑配置源弹窗
    CloseEditSource(data){
        this.province_flag = data
    },
    //编辑配置源成功后关闭弹窗
    CloseEditSourceDialog(data){
        this.province_flag = data
        this.query_sorcelist()
    },
    add_building_List_length() {
      var len = this.building_list.length
      this.building_list.push({'index': len})
      this.$store.state.protocol_data.push({
        name: '',
        func_no_outside: '',
        func_no_inside: '',
        data_type: '',
        id: '',
      })
    },
    remove_building_List_length() {
      var len = this.building_list.length
      this.building_list.splice(len - 1, 1)
      this.$store.state.protocol_data.splice(len - 1, 1)
    },
    handleClose_Left(flag = 1) {
      this.dialogVisible_left = false
      if (flag === 1) {
        this.remove_left()
      }
      //清空数据
      this.remark_list = [{key: '', value: ''}]
      this.plat_attr_list = []
      this.group_name = ''
    },
    handleClose_canter() {
      // this.pro_flag = false
      this.$store.commit('set_project_data', [])
      this.$store.commit('data_base_data', [])
      this.dialogVisible_canter = false
      // this.remove_canter()
    },
    remove_left() {

      this.plat_flag = false
      var obj = [{
        database_type: '后端',
        database_server_name: 'cloud',
        database_name: '',
        database_ip: '',
        database_port: '',
        database_user: '',
        database_passwd: '',
        remark: '',
        real_ip: '',
        real_port: '',
      },
        {
          database_type: '后端',
          database_server_name: 'event',
          database_name: '',
          database_ip: '',
          database_port: '',
          database_user: '',
          database_passwd: '',
          remark: '',
          real_ip: '',
          real_port: '',
        },
        {
          database_type: '后端',
          database_server_name: 'record',
          database_name: '',
          database_ip: '',
          database_port: '',
          database_user: '',
          database_passwd: '',
          remark: '',
          real_ip: '',
          real_port: '',
        }, {
          database_type: '缓存',
          database_server_name: 'redis',
          database_name: 'redis',
          database_ip: '',
          database_port: '',
          database_user: '',
          database_passwd: '',
          remark: '',
          real_ip: '',
          real_port: '',
        },
        {
          database_type: '缓存',
          database_server_name: 'celery',
          database_name: 'celery',
          database_ip: '',
          database_port: '',
          database_user: '',
          database_passwd: '',
          remark: '',
          real_ip: '',
          real_port: '',
        }, {
          database_type: '分发',
          database_server_name: 'original',
          database_name: '',
          database_ip: '',
          database_port: '',
          database_user: '',
          database_passwd: '',
          remark: '',
          real_ip: '',
          real_port: '',
        }
      ]
      this.$store.commit('data_base_data', obj)
      this.$nextTick(() => {
        this.plat_flag = true
      })
      // this.query_Info()
    },
    remove_canter() {
      this.query_pro_attr()
      this.$refs.pro_temp.clear_pro_data();

    },
    remove_right() {
      this.show_GetSonBulidingData = false
      this.protocol_name = ""
      for (let i in this.$refs.chirld_building) {
        this.$refs.chirld_building[i].clearData()
      }
      //     var obj=[  {
      //           name: '',
      //           func_no_outside: '',
      //           func_no_inside: '',
      //           data_type: '',
      //           id: '',
      //       }]
      // this.$store.commit('get_protocol_data', obj)
      this.show_GetSonBulidingData = true

      // this.query_AgreementInfo()
    },
    handleSizeChange1(val) {
      this.pageSize1 = val;
      this.query_Info();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange1(val) {
      this.currentPage1 = val;
      this.query_Info();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.query_project_list()
      this.$router.push({ 
        path: '/IBMS/platform/createNewProject', 
        query: { projectSize: val, projectCurrent: this.currentPage2 }
      })
    },
    //改变数据源配置页码
    handleSizeChange5(val) {
      this.pageSize5 = val;
      this.query_sorcelist()
    },
    handleCurrentChange5(val) {
      this.currentPage5 = val;
      this.query_sorcelist()
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.query_project_list()
      this.$router.push({ 
        path: '/IBMS/platform/createNewProject', 
        query: { projectSize: this.pageSize2, projectCurrent: val }
      })
    },
    handleSizeChange3(val) {
      this.pageSize3 = val;
      this.query_AgreementInfo()
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange3(val) {
      this.currentPage3 = val;
      this.query_AgreementInfo()
    },
    platformVisible_page() {
      this.pageSize1 = 9999;
      this.query_Info()
    },
    //查询数据库源
  query_sorcelist(){
    this.$axios({
      url: this.IBMS_API + 'IBMS/DeliveryPlatform/GetDataSourceList',
      params: {
          "page":this.currentPage5,
          "size":this.pageSize5,
      },
    }).then((response) => {
      console.log(response.data.data,'查询数据库源')
      this.SourceList = response.data.data
      this.SourceTotal = response.data.totalElements
    })
  },
    //平台列表
    query_list() {
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'Common/QueryPlatforms',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {}
        },
      }).then((response) => {
        this.platform_data_list = response.data.content
      })
    },
    //查询平台列表
    query_Info() {
      this.loading1 = true
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          "page": this.currentPage1,
          "size": this.pageSize1,
          "object_code": '10',
        },
      }).then((response) => {
        this.platform_TableData = response.data.content.data
        this.total1 = response.data.content.totalElements
        this.loading1 = false
      })
    },
    //查询协议列表
    query_AgreementInfo() {
      this.loading3 = true
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectList',
        params: {
          "object_code": this.radio,
          "page": this.currentPage3,
          "size": this.pageSize3,
        },
      }).then((response) => {
        this.enter_Information = response.data.content.data
        this.total3 = response.data.content.totalElements
        this.loading3 = false
      })
    },
    //平台编辑
    toEdit_plat(row) {
      // this.load=true
      this.remark_list = []
      this.plat_flag_son = false
      this.temp_list = []
      this.dialogVisible_left = true
      // this.platform_id = row.platform_id
      this.loading1 = true
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectDetailTree',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "id": row.id,
          }
        },
      }).then((response) => {
        this.plat_attr_list = response.data.content
        this.$store.commit('set_plat_data', this.plat_attr_list)

        this.group_name = response.data.content.platform_belongs_to_function_group
        if (this.plat_attr_list.object_data.remark === {}) {
          var k = Object.keys(this.plat_attr_list.object_data.remark)
          var v = Object.values(this.plat_attr_list.object_data.remark)
          for (let i in k) {
            this.remark_list.push({key: k[i], value: v[i]})
          }
        }
      })
    },
    //编辑平台
    edit() {
      var arry = this.plat_attr_list.database_obj
      for (let i in arry) {
        if (arry[i].database_name === '' || arry[i].database_ip === '' || arry[i].database_port === ''
            || arry[i].database_user === '' || arry[i].database_passwd === '' || arry[i].database_server_name === ''
            || arry[i].database_type === '' || arry[i].real_ip === '' || arry[i].real_port === '') {
          this.$message({
            type: 'error',
            message: '请填写数据库完整信息'
          });
          return;

        }
      }
      if (this.plat_attr_list.platform_belongs_to_function_group.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择功能组'
        });
        return;
      }
      let check = this.$check_data([this.$store.state.plat_data.object_data.static_attribute])
      if (!check) {
        return
      }
      this.fullscreenLoading = true
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/UpdateObject',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "object_data":this.$store.state.plat_data,
          }
        },
      }).then((response) => {
        this.fullscreenLoading = false
        if (response.data.result === 200) {
          this.$message({
            message: '编辑成功',
            type: 'success'
          });
          this.dialogVisible_left = false
          this.query_Info()
        } else if (response.data.result === 9999) {
          this.$message({
            message: '未知异常',
            type: 'error'
          });
        }
      })
    },

    //查询协议详情
    query_agree_detail(row) {
      this.agree_flag = false
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/QueryObjectDetailTree',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "id": String(row.id),
          }
        },
      }).then((response) => {
        this.$store.commit('get_protocol_data', response.data.content.object_data)
        this.agree_flag = true
      })
      this.dialogVisible_right = true
    },

    //删除平台
    delete_left(id) {
      this.fullscreenLoading = true
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/DeprecatOrDeleteObject',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "id_list": [id],
            "flag": 'delete',
          }
        },
      }).then((response) => {
        this.fullscreenLoading = false
        if (response.data.result === 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.query_Info()
        } else if (response.data.result === 9999) {
          this.$message({
            message: '未知异常',
            type: 'error'
          });
        } else if (response.data.result === 6678) {
          this.$message({
            message: '平台下已有项目不能删除',
            type: 'error'
          });
        }
      })
    },
    //删除协议
    delete_right(id) {
      this.fullscreenLoading = true
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/DeprecatOrDeleteObject',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "id_list": [id],
            "flag": 'delete',
          }
        },
      }).then((response) => {
        this.fullscreenLoading = false
        if (response.data.result === 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.query_AgreementInfo()
        } else if (response.data.result === 9999) {
          this.$message({
            message: '未知异常',
            type: 'error'
          });
        }
      })
    },
    open_left(row) {
      this.platform_Id = row.platform_id
      this.$confirm('此操作将永久删除该平台, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delete_left(row.id);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    open_func(row) {
      this.func_group_id = row.id
      this.$confirm('此操作将永久删除该功能组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delete_func();
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    open_func_group(row) {
      this.func_group_id = row.id
      this.$confirm('此操作将永久删除该功能组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delete_func_group(row);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //获取数据源配置详情
    GetSourceInfo(row){
      console.log(row)
      this.SourceInfo = row
      console.log(this.SourceInfo,'this.SourceInfo')
      this.province_flag=true
    },
    //删除该数据源
    RoumoveSource(row){
      console.log(row)
      this.project_id = row.id
      this.$confirm('此操作将永久删除该配置源, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DeleteSource(row.id)

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    open_canter(row) {
      this.project_id = row.id
      this.$confirm('此操作将永久删除该{' + row.name + '}, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.detele_project()

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    open_right(row) {
      this.informationId = row.id
      this.$confirm('此操作将永久删除该协议, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delete_right(row.id);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //删除功能组
    delete_func() {
      this.fullscreenLoading = true
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/DeprecatOrDeleteObject',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "id_list": [this.func_group_id],
            "flag": 'delete',
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
        this.Query_funcGroup_list()
        this.func_group_id = ''
        this.fullscreenLoading = false
      })
    },
    //删除功能组可用类型
    delete_func_group(row) {
      this.fullscreenLoading = true
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/DeliveryPlatform/DeleteFuncGroupType',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "func_group_type_name": row.func,
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }
        this.query_type_list()
        this.fullscreenLoading = false
      })
    },
    add_input_List_length() {
      this.plat_flag_son = false
      var len = this.temp_list.length
      this.temp_list.push({'index': len})
      this.$store.state.data_base.push({
        database_name: '',
        database_ip: '',
        database_port: '',
        database_user: '',
        database_passwd: '',
        database_server_name: '',
        database_type: '',
        remark: '',
        real_ip: '',
        real_port: '',
      })
      this.show_input = 1
      this.$store.commit('show_input', this.show_input)
      this.$nextTick(() => {
        this.plat_flag_son = true
      })
    },
    remove_input_List_length() {
      var len = this.temp_list.length
      this.temp_list.splice(len - 1, 1)
      this.$store.state.data_base.splice(len - 1, 1)
    },
  },
}
</script>
<style scoped>
.el-pager li {
  color: black !important;
}

.card {
}

.el-tooltip__popper {
  max-width: 20%;
}

.el-tooltip__popper, .el-tooltip__popper.is-dark {
  background: rgb(48, 65, 86) !important;
  color: #fff !important;
  line-height: 24px;
}

.el_row .card {
  max-height: 500px;
  overflow-y: auto;
}

.el-dialog_body {
  height: 60vh !important;
  overflow: auto;
}

.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 13px;
}
</style>
